import type { ReactNode } from 'react';
import React, { useState } from 'react';

import type {
  AIProviderEnum,
  AnalysisIdOrLatest,
  BrandId,
} from '../api/generated/insights.schemas';
import { BrandAnalysisDataProvider } from './BrandAnalysisDataContext';
import { BrandAnalysisMutationsProvider } from './BrandAnalysisMutationsContext';
import type { HostAppProps } from './types';

interface BrandAnalysisProviderProps {
  children: ReactNode;
  hostAppProps?: HostAppProps;
}

export const BrandAnalysisProvider: React.FC<BrandAnalysisProviderProps> = ({
  children,
  hostAppProps = {},
}) => {
  const [brandId, setBrandId] = useState<BrandId | undefined>(undefined);
  const [analysisId, setAnalysisId] = useState<AnalysisIdOrLatest>('latest');
  const [model, setModel] = useState<AIProviderEnum | undefined>(undefined);

  return (
    <BrandAnalysisMutationsProvider
      brandId={brandId}
      setBrandId={setBrandId}
      analysisId={analysisId}
      setAnalysisId={setAnalysisId}
      model={model}
      setModel={setModel}
    >
      <BrandAnalysisDataProvider
        brandId={brandId}
        analysisId={analysisId}
        model={model}
        hostAppProps={hostAppProps}
      >
        {children}
      </BrandAnalysisDataProvider>
    </BrandAnalysisMutationsProvider>
  );
};
